<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <div class="row">
      <div class="offset-7 col-4">
        <label for="createTriggerType">Trigger type</label>
        <multiselect
          id="createTriggerType"
          v-model="createTriggerTypeSelected"
          :options="createTriggerTypeOptions"
          label="text"
          track-by="text"
          class="input-margin"
        >
        </multiselect>
        <div
          v-if="isSubmit && $v.createTriggerTypeSelected.$invalid"
          class="text-error"
        >
          Please specify
        </div>
      </div>
      <div class="col-1" style="margin-top: 2.2rem">
        <button @click="createCrmTrigger" class="btn btn-outline-primary">
          Create
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <BrandDropdown
          v-model="brandSelected"
          @setBrand="setBrand"
          class="input-margin"
        ></BrandDropdown>
      </div>
      <div class="col-4">
        <label for="triggerType">Trigger type</label>
        <multiselect
          id="triggerType"
          v-model="triggerTypeSelected"
          :options="triggerTypeOptions"
          label="text"
          track-by="text"
          class="input-margin"
        >
        </multiselect>
      </div>
      <div class="col-4">
        <label for="status">Status</label>
        <multiselect
          id="status"
          v-model="statusSelected"
          :options="statusOptions"
          label="text"
          track-by="text"
          class="input-margin"
        >
        </multiselect>
      </div>
    </div>
    <div class="row mt-0">
      <div class="col-4">
        <label for="startDateFrom">Start date from</label>
        <date-picker
          id="startDateFrom"
          v-bind="$attrs"
          v-model="startDateFrom"
          format="D MMMM yyyy"
          lang="en"
          :value="startDateFrom"
          @change="
            changeStartDate($event);
            startDateFrom = $event;
          "
        />
      </div>
      <div class="col-4">
        <label for="startDateTo">Start date to</label>
        <date-picker
          id="startDateTo"
          v-bind="$attrs"
          v-model="startDateTo"
          format="D MMMM yyyy"
          lang="en"
          :value="startDateTo"
          :minDate="startDateFrom"
          @change="startDateTo = $event"
        />
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <div class="p-2 align-self-center">
        <button
          class="btn btn-outline-secondary"
          style="width: 100%; max-width: 131px"
          @click="resetFilter"
        >
          Reset
        </button>
      </div>
      <div class="p-2 align-self-center">
        <button
          class="btn btn-outline-primary"
          style="width: 100%; max-width: 131px"
          @click="searchCrmTrigger"
        >
          Search
        </button>
      </div>
    </div>

    <div class="mt-3">
      <div class="row">
        <div class="d-flex align-items-center justify-content-start col">
          <span class="mr-2">Show</span>
          <b-form-select
            class="form-control w-auto"
            v-model="perPage"
            :options="pageOptions"
            @change="onChangeEntries"
          ></b-form-select>
          <span class="ml-2">entries</span>
        </div>
      </div>
      <b-table
        class="table table-responsive table-bordered mt-5"
        hover
        responsive
        :fields="fields"
        :items="listCrmTriggers"
        :per-page="perPage"
        @sort-changed="sortCompare"
        show-empty
      >
        <template #empty>
          <h1 class="text-center m-5">ไม่มีข้อมูลที่แสดง</h1>
        </template>
        <template #cell(action)="data">
          <div class="d-flex justify-content-evenly">
            <router-link
              :to="{
                name: 'DetailCrmTrigger',
                query: { id: data.item.id },
              }"
              class="btn btn-outline-primary"
              >View</router-link
            >
          </div>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
        class="my-0"
        aria-controls="my-table"
        @input="changePage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import BrandDropdown from "components/Brand/BrandDropdown";
import CrmTriggerService from "services/api/crmTrigger.service";
import CrmTriggerTypeService from "services/api/crmTriggerType.service";
import { CrmTriggerStorageService } from "services/storage.service";
import { required } from "vuelidate/lib/validators";
import DefaultListViewData from "@/views/defaultListViewData";
import DatePicker from "components/Datepicker/Datepicker.vue";

export default {
  components: {
    DatePicker,
    BrandDropdown,
  },

  data() {
    return {
      ...DefaultListViewData,
      sort: { ...DefaultListViewData.sort },
      createTriggerTypeSelected: null,
      createTriggerTypeOptions: [],
      triggerTypeSelected: null,
      triggerTypeOptions: [],
      statusSelected: null,
      statusOptions: [{ text: "Active" }, { text: "Inactive" }],
      startDateFrom: null,
      startDateTo: null,
      isLoading: true,
      listCrmTriggers: [],
      fields: [
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "triggerType",
          label: "Type",
          sortable: true,
        },
        {
          key: "brandCode",
          label: "Brand code",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "startDate",
          label: "Start date",
          sortable: true,
        },
        {
          key: "endDate",
          label: "End date",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
        },
      ],
      isSubmit: false,
    };
  },
  validations: {
    createTriggerTypeSelected: {
      required,
    },
  },
  mounted() {
    this.brandSelected =
      JSON.parse(CrmTriggerStorageService.getStoredBrand()) || {};
    this.triggerTypeSelected =
      JSON.parse(CrmTriggerStorageService.getStoredTriggerType()) || {};
    this.statusSelected =
      JSON.parse(CrmTriggerStorageService.getStoredStatus()) || {};
    this.startDateFrom =
      JSON.parse(CrmTriggerStorageService.getStoredStartDateFrom()) || null;
    this.startDateTo =
      JSON.parse(CrmTriggerStorageService.getStoredStartDateTo()) || null;
    let storedParams =
      JSON.parse(CrmTriggerStorageService.getStoredParams()) || {};

    if (storedParams) {
      this.currentPage = storedParams.currentPage || 1;
      this.perPage = storedParams.limit || 10;
      this.sort.key = storedParams.sortColumn;
      this.sort.type = storedParams.sortType;
    }

    this.getCrmTriggerList(this.sort);
    this.getCrmTriggerTypeForList();
    this.getCrmTriggerTypeForCreate();
    CrmTriggerStorageService.removeCreateTriggerType();
  },

  methods: {
    async getCrmTriggerList(sort) {
      const params = {
        brandCode: this.brandSelected ? this.brandSelected.id : null,
        startDateFrom: this.startDateFrom,
        startDateTo: this.startDateTo,
        triggerType: this.triggerTypeSelected
          ? this.triggerTypeSelected.text
          : null,
        status: this.statusSelected
          ? this.statusSelected.text?.toUpperCase()
          : null,
        currentPage: this.currentPage,
        limit: this.perPage,
        sortColumn: sort.key || "id",
        sortType: sort.type || "desc",
      };
      await CrmTriggerStorageService.setStoredBrand(this.brandSelected);
      await CrmTriggerStorageService.setStoredTriggerType(
        this.triggerTypeSelected
      );
      await CrmTriggerStorageService.setStoredStatus(this.statusSelected);
      await CrmTriggerStorageService.setStoredStartDateFrom(this.startDateFrom);
      await CrmTriggerStorageService.setStoredStartDateTo(this.startDateTo);
      await CrmTriggerStorageService.setStoredParams(params);

      await CrmTriggerService.getListCrmTrigger(params)
        .then((res) => {
          const data = res.data;
          this.totalItems = data.totalItems;
          this.listCrmTriggers = data.crmTriggers.map((c) => {
            return {
              ...c,
              status: c.status === "ACTIVE" ? "Active" : "Inactive",
            };
          });

          this.isLoading = false;
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.isLoading = false;
        });
    },
    async getCrmTriggerTypeList(params, triggerType) {
      await CrmTriggerTypeService.getListCrmTriggerType(params)
        .then((res) => {
          const data = res.data;
          if (triggerType === this.triggerTypeOptions) {
            this.triggerTypeOptions = data.triggerTypes.map((t) => {
              return {
                text: t.name,
                brandCode: t.brandCode,
              };
            });
          } else if (triggerType === this.createTriggerTypeOptions) {
            this.createTriggerTypeOptions = data.triggerTypes.map((t) => {
              return {
                text: t.name,
                brandCode: t.brandCode,
              };
            });
          }
          this.isLoading = false;
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.isLoading = false;
        });
    },
    async getCrmTriggerTypeForList() {
      const params = {
        brandCode: this.brandSelected ? this.brandSelected.id : null,
      };
      await this.getCrmTriggerTypeList(params, this.triggerTypeOptions);
    },
    async getCrmTriggerTypeForCreate() {
      const params = {
        brandCode: null,
      };
      await this.getCrmTriggerTypeList(params, this.createTriggerTypeOptions);
    },
    changePage() {
      this.getCrmTriggerList(this.sort);
    },
    onChangeEntries() {
      this.getCrmTriggerList(this.sort);
    },
    sortCompare(e) {
      let sortBy = e.sortBy;
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getCrmTriggerList(this.sort);
    },
    changeStartDate(val) {
      if (val > this.startDateTo) {
        this.startDateTo = null;
      }
    },
    setBrand(brand) {
      this.brandSelected = brand || null;
      this.changeBrand();
    },
    changeBrand() {
      this.triggerTypeSelected = null;
      this.getCrmTriggerTypeForList();
    },
    searchCrmTrigger() {
      this.isLoading = true;
      this.getCrmTriggerList(this.sort);
    },
    resetFilter() {
      this.brandSelected = null;
      this.triggerTypeSelected = null;
      this.statusSelected = null;
      this.startDateFrom = null;
      this.startDateTo = null;
      CrmTriggerStorageService.setStoredTriggerType(this.triggerTypeSelected);
      CrmTriggerStorageService.setStoredStatus(this.statusSelected);
      CrmTriggerStorageService.setStoredStartDateFrom(this.startDateFrom);
      CrmTriggerStorageService.setStoredStartDateTo(this.startDateTo);
      this.getCrmTriggerList(this.sort);
    },
    createCrmTrigger() {
      this.isSubmit = true;
      const vm = this.$v;
      if (!vm.$invalid) {
        this.$router.push({ name: "DetailCrmTrigger" });
        CrmTriggerStorageService.setCreateTriggerType(
          this.createTriggerTypeSelected
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  margin: 1rem 0;
}
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}

.input-margin {
  margin: 0.6rem 0;
}
</style>
